module.exports = __webpack_public_path__ + "img/qrcode_frame_2.3972f230.png";